(function () {
function $df3a6a6b5c2bc25f$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $46a23bcc7c68dc1c$export$184ff5d81c0e5775(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $dde2e846e27cc96a$export$20c20a422940e173(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $4403162f290731b1$export$5a67b255b80ee4f2(receiver, privateMap) {
    var descriptor = (0, $dde2e846e27cc96a$export$20c20a422940e173)(receiver, privateMap, "get");
    return (0, $46a23bcc7c68dc1c$export$184ff5d81c0e5775)(receiver, descriptor);
}


function $35d2585671c1a6f9$export$6b10452b5ac97eba(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $5573f760138621ba$export$e235798705076415(obj, privateMap, value) {
    (0, $35d2585671c1a6f9$export$6b10452b5ac97eba)(obj, privateMap);
    privateMap.set(obj, value);
}


function $3107e1a42f5d4644$export$b7b24cdba6bcb11c(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $27e893c3b324483f$export$268446c9779b3a21(receiver, privateMap, value) {
    var descriptor = (0, $dde2e846e27cc96a$export$20c20a422940e173)(receiver, privateMap, "set");
    (0, $3107e1a42f5d4644$export$b7b24cdba6bcb11c)(receiver, descriptor, value);
    return value;
}


function $4a3cfad73b42fe71$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4a3cfad73b42fe71$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $4a3cfad73b42fe71$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4a3cfad73b42fe71$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $c01f55302f13722b$var$swiper = new Swiper(".swiper", {
    direction: "horizontal",
    loop: true,
    effect: "flip",
    limitRotation: true,
    slideShadows: true,
    speed: 800,
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    pagination: {
        el: ".swiper-pagination"
    }
});
var $c01f55302f13722b$var$_el = /*#__PURE__*/ new WeakMap(), $c01f55302f13722b$var$_config = /*#__PURE__*/ new WeakMap();
var $c01f55302f13722b$var$ItcAccordion = /*#__PURE__*/ function() {
    function ItcAccordion(target, config) {
        (0, $df3a6a6b5c2bc25f$export$2996f80ef42b8419)(this, ItcAccordion);
        (0, $5573f760138621ba$export$e235798705076415)(this, $c01f55302f13722b$var$_el, {
            writable: true,
            value: void 0
        });
        (0, $5573f760138621ba$export$e235798705076415)(this, $c01f55302f13722b$var$_config, {
            writable: true,
            value: void 0
        });
        (0, $27e893c3b324483f$export$268446c9779b3a21)(this, $c01f55302f13722b$var$_el, typeof target === "string" ? document.querySelector(target) : target);
        var defaultConfig = {
            alwaysOpen: true
        };
        (0, $27e893c3b324483f$export$268446c9779b3a21)(this, $c01f55302f13722b$var$_config, Object.assign(defaultConfig, config));
        if ((0, $4403162f290731b1$export$5a67b255b80ee4f2)(this, $c01f55302f13722b$var$_el)) this.addEventListener();
        else console.warn("ItcAccordion: Target element not found.");
    }
    (0, $4a3cfad73b42fe71$export$d60067ff2358eee8)(ItcAccordion, [
        {
            key: "addEventListener",
            value: function addEventListener() {
                var _this = this;
                (0, $4403162f290731b1$export$5a67b255b80ee4f2)(this, $c01f55302f13722b$var$_el).addEventListener("click", function(e) {
                    var elHeader = e.target.closest(".accordion__header");
                    if (!elHeader) return;
                    var elItem = elHeader.parentElement;
                    var isOpen = elItem.classList.contains("accordion__item_show");
                    if (!(0, $4403162f290731b1$export$5a67b255b80ee4f2)(_this, $c01f55302f13722b$var$_config).alwaysOpen) {
                        var elOpenItem = (0, $4403162f290731b1$export$5a67b255b80ee4f2)(_this, $c01f55302f13722b$var$_el).querySelector(".accordion__item_show");
                        if (elOpenItem && elOpenItem !== elItem) elOpenItem.classList.remove("accordion__item_show");
                    }
                    elItem.classList.toggle("accordion__item_show", !isOpen);
                });
            }
        }
    ]);
    return ItcAccordion;
}();
// export default ItcAccordion;
// import ItcAccordion from './index.js';
new $c01f55302f13722b$var$ItcAccordion(".accordion", {
    alwaysOpen: false
});

})();
//# sourceMappingURL=index.55eee042.js.map
